var React = require('react');

function HouseInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M79 0 .448 65.608h13.28V144h46.18V92.728h38.18V144h46.552V65.608h12.908L79 0Z","fill":"currentColor"}));
}

HouseInline.defaultProps = {"width":"158","height":"144","viewBox":"0 0 158 144","fill":"none"};

module.exports = HouseInline;

HouseInline.default = HouseInline;
